export const defaultState = {
    id: "",
    email: "",
    fullname: "",
    photoURL: "",
    isLogged: false,
};

// actions type
import {
    ACCOUNT_LOGIN,
    ACCOUNT_LOGOUT
} from "~/actions/account";

const saveAccountLogin = (account: object) => ({ isLogged: true, ...account })

export default function(state = defaultState, { ...action }) {
    switch(action.type) {
        case ACCOUNT_LOGIN: return saveAccountLogin(action.account)
        case ACCOUNT_LOGOUT: return { ...defaultState }
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/session/account.ts